// Generated by purs version 0.14.3
"use strict";
var Data_Unit = require("../Data.Unit/index.js");
var RightModule = function (Ring0, maddR, mmulR, msubR, mzeroR) {
    this.Ring0 = Ring0;
    this.maddR = maddR;
    this.mmulR = mmulR;
    this.msubR = msubR;
    this.mzeroR = mzeroR;
};
var LeftModule = function (Ring0, maddL, mmulL, msubL, mzeroL) {
    this.Ring0 = Ring0;
    this.maddL = maddL;
    this.mmulL = mmulL;
    this.msubL = msubL;
    this.mzeroL = mzeroL;
};
var rightModuleUnit = function (dictRing) {
    return new RightModule(function () {
        return dictRing;
    }, function (v) {
        return function (v1) {
            return Data_Unit.unit;
        };
    }, function (v) {
        return function (v1) {
            return Data_Unit.unit;
        };
    }, function (v) {
        return function (v1) {
            return Data_Unit.unit;
        };
    }, Data_Unit.unit);
};
var mzeroR = function (dict) {
    return dict.mzeroR;
};
var mzeroL = function (dict) {
    return dict.mzeroL;
};
var msubR = function (dict) {
    return dict.msubR;
};
var msubL = function (dict) {
    return dict.msubL;
};
var mnegateR = function (dictRightModule) {
    return function (v) {
        return msubR(dictRightModule)(mzeroR(dictRightModule))(v);
    };
};
var mnegateL = function (dictLeftModule) {
    return function (v) {
        return msubL(dictLeftModule)(mzeroL(dictLeftModule))(v);
    };
};
var mmulR = function (dict) {
    return dict.mmulR;
};
var mmulL = function (dict) {
    return dict.mmulL;
};
var maddR = function (dict) {
    return dict.maddR;
};
var maddL = function (dict) {
    return dict.maddL;
};
var leftModuleUnit = function (dictRing) {
    return new LeftModule(function () {
        return dictRing;
    }, function (v) {
        return function (v1) {
            return Data_Unit.unit;
        };
    }, function (v) {
        return function (v1) {
            return Data_Unit.unit;
        };
    }, function (v) {
        return function (v1) {
            return Data_Unit.unit;
        };
    }, Data_Unit.unit);
};
module.exports = {
    LeftModule: LeftModule,
    mzeroL: mzeroL,
    maddL: maddL,
    msubL: msubL,
    mmulL: mmulL,
    mnegateL: mnegateL,
    RightModule: RightModule,
    mzeroR: mzeroR,
    maddR: maddR,
    msubR: msubR,
    mmulR: mmulR,
    mnegateR: mnegateR,
    leftModuleUnit: leftModuleUnit,
    rightModuleUnit: rightModuleUnit
};
